import { render, staticRenderFns } from "./DaysHeader.vue?vue&type=template&id=2ca66568&scoped=true&"
import script from "./DaysHeader.vue?vue&type=script&lang=js&"
export * from "./DaysHeader.vue?vue&type=script&lang=js&"
import style0 from "./DaysHeader.vue?vue&type=style&index=0&id=2ca66568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca66568",
  null
  
)

export default component.exports